export const convertUTCDateToLocalDate = (date) => {
  date = new Date(date);
  var newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
  return newDate.toLocaleString();
};
